<template>
  <div>
    <h2 class="text-left alert" :class="[ removed ? 'alert-danger' : 'alert-success' ]">
      Milk Cultures
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[ removed ? 'glyphicon-plus' : 'glyphicon-remove' ]"></span>
      </a>
    </h2>

    <template v-if="!removed">
      <div class="text-left step-section" >
        <h2 class="text-left" :class="isRemovedSubsection('mastatest_results') ? 'comment-disabled' : ''">
           Mastatest Results 
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'mastatest_results')">
            <span class="glyphicon" :class="isRemovedSubsection('mastatest_results') ? 'glyphicon-plus' : 'glyphicon-remove'"></span>
          </a>
        </h2>
        <report-comment field_name="heading_mastatest_results" :model="model.COMMENTS" :heading="true">
        </report-comment>

        <div v-for="(farmResult, index) in model.CHARTS.dc_mastatest_results" :key="'farm_ma_result_'+index">
          <h3> {{ farmResult.farm_label }} </h3>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Date</th>
                <th>In-house</th>
                <th>Cow number</th>
                <th>Quarter</th>
                <th>Pathogens present</th>
                <th>Antibiotic susceptibility</th>
                <th>Recommendation/Comments</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in farmResult.result" :key="'farm_ma_row_'+index">

                <td class="text-left">{{ row["Date"] }}</td>
                <td class="text-left">{{ row["In-house"] }}</td>
                <td class="text-left">{{ row["Cow number"] }}</td>
                <td class="text-left">{{ row["Quarter"] }}</td>
                <td class="text-left" v-html="commaSeparatedValue(row['Pathogens present'])"></td>
                <td class="text-left" v-html="commaSeparatedValue(row['Antibiotic susceptibility'])"></td>
                <td class="text-left">{{ row["Recommendation/Comments"] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="text-left step-section">
        <h2 class="text-left" :class="isRemovedSubsection('gribbles_results') ? 'comment-disabled' : ''">
           Gribbles results
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'gribbles_results')">
            <span class="glyphicon" :class="isRemovedSubsection('gribbles_results') ? 'glyphicon-plus' : 'glyphicon-remove'"></span>
          </a>
        </h2>
        <report-comment field_name="heading_gribbles_results" :model="model.COMMENTS" :heading="true">
        </report-comment>

        <div v-for="(farmResult, index) in model.CHARTS.dc_gribbles_results" :key="'farm_gri_result_'+index">
          <h3> {{ farmResult.farm_label }} </h3>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Date</th>
                <th>Test</th>
                <th>Results</th>
                <th>Antibiotic sensitivity</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in farmResult.result" :key="'farm_gri_row_'+index">
                <td class="text-left">{{ row["Date"] }}</td>
                <td class="text-left">{{ row["Test"] }}</td>
                <td class="text-left" v-html="commaSeparatedValue(row['Results'])"></td>
                <td class="text-left" v-html="commaSeparatedValue(row['Antibiotic sensitivity'])"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'
import ReportComment from '../ReportComment'

export default {
  mixins: [ mixin ],
  components: {
    ReportComment
  },
  props: ['model'],
  data() {
    return {
      stepName: 'MilkCultures',
    }
  },
  methods: {
    commaSeparatedValue: function(str) {
      let text = ''
      let splittedText = str.split(', ')

      if (!(splittedText.length == 1 && splittedText[0] == '')) {
        splittedText.forEach(function(item) {
          text += '<p>- '+ item +'</p>'
        })
      }
      return text
    }
  }
};
</script>
